/**
 * Класс для визуального редактирования геометрии.
 * Принимает геометрию, пользователь ее как-то редактирует, а потом можно получить
 * обратно уже отредактированную геометрию.
 */

function getLayerStyle(scale) {

    if (scale === undefined) {
        scale = 1;
    }

    var circle = new ol.style.Circle({
        radius: 6 * scale,
        fill  : new ol.style.Fill({
            color: /*'#6666ff*/'#0086b3'
        }),
        stroke: new ol.style.Stroke({
          color: [255, 255, 255, 1],
          width: 3 * scale
        })
    });

    if (scale !== 1) {
        circle.setScale(1 / scale);
    }

    return [
        /* стиль для дополнительной обводки */
        new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: '#ffffff',
                width: 10,
            }),
        }),
        /* обычный стиль */
        new ol.style.Style({
            fill  : new ol.style.Fill({
                color: 'rgba(0, 134, 179, 0.2)'
            }),
            stroke: new ol.style.Stroke({
                color: '#0086b3',
                width: 4
            }),
            image : circle
        })
    ];
}

function getModifyStyle(scale) {

    if (scale === undefined) {
        scale = 1;
    }

    var image = new ol.style.Circle({
        radius: 6 * scale,  /* различие между двумя стилями */
        fill: new ol.style.Fill({
            color: /*'#6666ff'*/'#00b7f9'
        }),
        stroke: new ol.style.Stroke({
            color: [255, 255, 255, 1],
            width: 4 * scale
        })
    });

    if (scale !== 1) { 
        image.setScale(1 / scale); 
    }

    return new ol.style.Style({
        image: image
    });
}

var Class       = require("Class"),
    Events      = require("Events"),
    Utils       = require("Utils"),
    ol          = require("openlayers");

var GenericGeometryEditor = Class.extend({
    includes: [ Events ],

    initialize: function(map) {
        var that = this;

        that.drawInteractionStyles = [
            new ol.style.Style({
                stroke: new ol.style.Stroke({
                    color: '#ffffff',
                    width: 10,
                }),
            }),
            new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(90, 160, 180, 0.2)'
                }),
                stroke: new ol.style.Stroke({
                    color: /*'#6666ff'*/'#0086b3',
                    lineDash: [5, 5],
                    width: 2
                }),
                image: new ol.style.Circle({
                    radius: 5,
                    stroke: new ol.style.Stroke({
                        color: 'rgba(0, 0, 0, 0.7)'
                    }),
                    fill: new ol.style.Fill({
                        color: 'rgba(255, 255, 255, 0.6)'
                    })
                })
            })
        ];

        that.map = map;
        that.source = new ol.source.Vector({
            features: []
        });
        that.layer = new ol.layer.Vector({
            source: that.source,
            style: getLayerStyle()
        });
        that.drawInteraction = null;
        that.currentGeomType = 'Unknown';
    },

    show: function() {
        var that = this;
        var map_has_layer = !!that.map.getLayers().getArray().filter(function(l) { 
            return l == that.layer; 
        })[0];
        if (!map_has_layer) {
            that.map.addLayer(that.layer);
        }
    },

    hide: function() {
        var that = this;
        that.map.removeLayer(that.layer);
    },

    isVisible: function() {
        var that = this;
        var layers = that.map.getLayers().getArray();
        var draw_layer = layers.filter(function(l) { return l === that.layer; });
        return !!draw_layer.length;
    },

    fireGeomChanged: function() {
        var that = this;
        that.fire('geomchange');
    },

    setFeatures: function(features) {
        var that = this;
        that.source.clear();
        that.map.removeInteraction(that.modifyInteraction);
        if (features) {
            that.source.addFeatures(features);
            that.fireGeomChanged();
        }
        var first_feature = features ? features[0] : false;
        if (first_feature) {
            that.currentGeomType = first_feature.getGeometry().getType();
        } else {
            that.currentGeomType = 'Unknown';
        }
    },

    addFeatures: function(features) {
        var that = this;
        if (features.length) {
            that.show();
            that.source.addFeatures(features);
            that.initModifyInteraction();
            that.fireGeomChanged();
        }
    },

    makeFeaturesFromGeom: function(geom) {
        var that = this;
        return that.parseGeoJSONToFeature(that.makeGeoJSONFromGeom(geom));
    },

    makeGeoJSONFromGeom: function (geom) {
        var geoJSON  = {};
        var geomType = (geom.type.indexOf("Multi") != -1) ?
            geom.type.substring(5, geom.type.length) : geom.type;
    
        if (geom.coordinates.length > 1 && geom.type.indexOf("Multi") != -1) {
            geoJSON = {
                "type"    : "FeatureCollection",
                "features": []
            };
    
            for (var i = 0; i < geom.coordinates.length; i++) {
                geoJSON.features.push({
                    "type"      : "Feature",
                    "geometry"  : {
                        "type"       : geomType,
                        "coordinates": geom.coordinates[i]
                    },
                    "properties": null
                })
            }
    
        } else {
            geoJSON = {
                "type"      : "Feature",
                "geometry"  : geom,
                "properties": {}
            };
        }
    
        return geoJSON;
    },

    setDblClickZoomActive: function (value) {
        var that = this;
        var map  = that.map;
    
        map.getInteractions().forEach(function (interact) {
            if (interact instanceof ol.interaction.DoubleClickZoom) {
                interact.setActive(!!value);
            }
        });
    },

    stopEverything: function() {
        var that = this;
        that.stopHoleDrawing();
        that.removeDeleteInteraction();
        that.removeDrawInteraction();
        that.map.removeInteraction(that.modifyInteraction);
    },

    initDrawing: function(geomtype) {
        var that = this;

        if (!that.isVisible()) {
            that.show();
        }

        that.stopEverything();

        that.currentGeomType = geomtype;

        that.drawInteraction = new ol.interaction.Draw({
            type: geomtype,
            features: new ol.Collection(that.layer.getSource().getFeatures()),
            wrapX: true,
            style: that.drawInteractionStyles
        });

        that.drawInteraction.on("drawstart", function () {
        });

        that.drawInteraction.on("drawend", function (evt) {
            that.layer.getSource().addFeature(evt.feature);
            that.fireGeomChanged();
            that.onDrawEnd();
            that.setDblClickZoomActive(true);
        })

        that.map.addInteraction(that.drawInteraction);

        that.setDblClickZoomActive(false);
    },

    removeDrawInteraction: function() {
        var that = this;
        that.map.removeInteraction(that.drawInteraction);
        that.drawInteraction = null;
    },

    removeAll: function() {
        var that = this;
        that.map.removeInteraction(that.drawInteraction);
        that.drawInteraction = null;
        that.map.removeInteraction(that.modifyInteraction);
        that.modifyInteraction = null;
        that.setFeatures(null);
        that.hide();
    },

    onDrawEnd: function() {
        var that = this;
        that.initModifyInteraction();
    },

    initModifyInteraction: function() {
        var that = this;
        that.map.removeInteraction(that.modifyInteraction);
        //that.map.removeInteraction(that.drawInteraction);

        that.modifyInteraction = new ol.interaction.Modify({
            features       : new ol.Collection(that.layer.getSource().getFeatures()),
            deleteCondition: function (event) {
                return ol.events.condition.singleClick(event);
            },
            wrapX : true,
            style: getModifyStyle()
        });

        that.modifyInteraction.on("modifystart", function () {
            that.modifyFlag = true;
        });

        that.modifyInteraction.on('modifyend', function() {
            that.fireGeomChanged();
        });

        that.map.addInteraction(that.modifyInteraction);
    },

    toGeoJSON: function(as_string, convert_to) {
        var that = this;
        var layerFeatures = that.layer.getSource().getFeatures();
        var formatGeoJSON = new ol.format.GeoJSON({dataProjection: "EPSG:3857"});

        var write_features_options = {
            featureProjection: "EPSG:3857"
        };
        if (convert_to && typeof convert_to === "string") {
            write_features_options['dataProjection'] = convert_to;
        }
        
        var parsedJSON = formatGeoJSON.writeFeatures(
            layerFeatures, 
            write_features_options
        );
        
        if (as_string) {
            return JSON.stringify(JSON.parse(parsedJSON), null, 2);
        } else {
            return JSON.parse(parsedJSON);
        }
    },

    parseGeoJSONToFeature: function(geojson, convert_from, convert_to) {
        convert_from = convert_from || "EPSG:3857";
        convert_to = convert_to || "EPSG:3857";

        var formatGeoJSON = new ol.format.GeoJSON();
        var feature = formatGeoJSON.readFeatures(geojson, {
            featureProjection: convert_to,
            dataProjection: convert_from
            // dataProjection: new ol.proj.Projection({code: "EPSG:3857"})
        });

        return feature;
    },

    isGeoJSONValid: function(geojson_string) {
        var that = this;
        var formatGeoJSON = new ol.format.GeoJSON({dataProjection: "EPSG:3857"});
        var JSONString    = geojson_string;
        var convertedFeature, parsedJSON;

        try {
            convertedFeature = formatGeoJSON.readFeatures(JSONString, {
                featureProjection: "EPSG:3857"
            });
            parsedJSON       = formatGeoJSON.writeFeatures(convertedFeature, {
                dataProjection: "EPSG:3857"
            });
        } catch (e) {
            console.log(e);
            return false;
        }

        try {
            var testLayer = new ol.layer.Vector();
            var features  = that.parseGeoJSONToFeature(geojson_string);
    
            testLayer.setSource(new ol.source.Vector({
                features: features
            }));
        } catch (e) {
            console.log(e);
            return false;
        }

        return true;
    },

    initHoleDrawing: function(callback) {
        var that = this;

        that.stopEverything();

        that.selectInt = new ol.interaction.Select({
            wrapX: true
        });

        that.setDblClickZoomActive(false);

        that.selectInt.on('select', function(event) {
            var selFeats = new ol.Collection(event.selected);
            if (selFeats.getLength() !== 1) {
                that.map.removeInteraction(that.selectInt);
                that.fire('error', {
                    message: 'Отверстия можно рисовать только в одном полигоне'
                });
                return;
            } else {
                var geomTypeSelected = selFeats.getArray()[0].getGeometry().getType();
                if (geomTypeSelected !== 'Polygon') {
                    that.fire('error', {
                        message: 'Отверстия можно рисовать только в полигонах. Вы выбрали ' + geomTypeSelected
                    });
                    that.map.removeInteraction(that.selectInt);
                    return;
                }

                //create a polygon draw interaction
                var vertsCouter      = 0; //this is the number of vertices drawn on the ol.interaction.Draw(used in the geometryFunction)
                var holeDraw         = new ol.interaction.Draw({
                    //source: that._layer,
                    wrapX           : true,
                    features        : new ol.Collection(that.layer.getSource().getFeatures()),
                    type            : 'Polygon',
                    //add the geometry function in order to disable
                    //hole creation outside selected polygon
                    geometryFunction: function (coords, geom) {
                        var retGeom; //define the geometry to return
                        if (typeof (geom) !== 'undefined') { //if it is defined, set its coordinates
                            geom.setCoordinates(coords);
                        } else {
                            retGeom = new ol.geom.Polygon(coords);
                        }
                        if (coords[0].length > vertsCouter) { //this is the case where new vertex has been draw
                            //check if vertex drawn is within the selected polygon
                            var isIn = that.isPointInPoly(selFeats.getArray()[0].getGeometry(), coords[0][coords[0].length - 1]);
                            //if outside get rid of it
                            if (isIn === false) {
                                coords[0].pop(); //remove the last coordinate element
                                retGeom = new ol.geom.Polygon(coords); //recunstract the geometry
                            }
                            vertsCouter = coords[0].length; //reset the length of vertex counter
                        }
                        return retGeom;
                    }

                });
                that.holeInteraction = holeDraw;
                //disable the select and modify interaction during hole drawing
                that.selectInt.setActive(false);
                that.modifyInteraction.setActive(false);
                //add the draw hole interaction
                that.map.addInteraction(holeDraw);
                //add the listener when start drawing
                holeDraw.on('drawstart', function (e) {
                    that.modifyFlag = true;
                    var feature     = e.feature; //grab the draw hole feature
                    var ringAdded   = false; //init boolen var to clarify whether drawn hole has allready been added or not
                    //set the change feature listener so get the hole like visual effect
                    feature.on('change', function (e) {
                        //get draw hole feature geometry
                        var drawCoords = feature.getGeometry().getCoordinates(false)[0];
                        //if hole has more than two cordinate pairs, add the interior ring to feature
                        if (drawCoords.length > 2) {
                            //if intirior ring has not been added yet, append it and set it as true
                            if (ringAdded === false) {
                                selFeats.getArray()[0].getGeometry().appendLinearRing(
                                    new ol.geom.LinearRing(feature.getGeometry().getCoordinates(false)[0]));
                                ringAdded = true;
                            }
                            //if interior ring has allready been added so we need to remove it and add back the updated one
                            else {
                                //get the elements length of the geometry
                                var coordElemntLength = selFeats.getArray()[0].getGeometry().getCoordinates().length;
                                var coordsExt         = selFeats.getArray()[0].getGeometry().getCoordinates()[0]; //exterior ring
                                var coordsInter       = []; //interior rings
                                //if we have more than 2 elements
                                if (coordElemntLength > 2) {
                                    //create the interior rings array
                                    //note that we use i=1 to leave outside the first element (exterior ring)
                                    //and coordElemntLength-1 to leave outside the last element as this is the one we need to update
                                    for (var i = 1; i < coordElemntLength - 1; i++) {
                                        coordsInter.push(selFeats.getArray()[0].getGeometry().getCoordinates()[i]);
                                    }
                                }
                                //construct the coordinates to use for the modify geometry feature
                                var setCoords = [];
                                //if interior rings allready exist
                                if (coordsInter.length > 0) {
                                    //push the exterior ring
                                    setCoords.push(coordsExt);
                                    //push all the interior rings
                                    for (var z = 0; z < coordsInter.length; z++) {
                                        setCoords.push(coordsInter[z]);
                                    }
                                    //and finally push the new drawn hole

                                    setCoords.push(feature.getGeometry().getCoordinates(false)[0]);
                                } else {

                                    setCoords = [coordsExt, feature.getGeometry().getCoordinates(false)[0]];
                                }
                                setCoords[setCoords.length - 1].push(
                                    [].concat(setCoords[setCoords.length - 1][0])
                                );
                                selFeats.getArray()[0].getGeometry().setCoordinates(setCoords);
                            }
                        }
                    });
                });

                //create a listener when finish drawing and so remove the hole interaction
                holeDraw.on('drawend', function (evt) {
                    // that.$hole.removeClass("active");
                    setTimeout(function(){
                        that.stopHoleDrawing();
                        that.setDblClickZoomActive(true);
                        callback();
                        that.fireGeomChanged();
                    }, 0);
                });
            }
        });

        that.map.addInteraction(that.selectInt);
    },

    stopHoleDrawing: function() {
        var that = this;
        that.map.removeInteraction(that.holeInteraction);
        that.map.removeInteraction(that.selectInt);
        that.initModifyInteraction();
    },

    isPointInPoly: function (polygon, pt) {
        var poly = polygon.getCoordinates()[0]; //only the exterior ring of the supplied polygon
        for (var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
            ((poly[i][1] <= pt[1] && pt[1] < poly[j][1]) || (poly[j][1] <= pt[1] && pt[1] < poly[i][1])) && (pt[0] < (poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1]) / (poly[j][1] - poly[i][1]) + poly[i][0]) && (c = !c);
        return c;
    },

    initDeleteSelect: function (callback) {
        var that = this;
        var selFeats;
        
        that.stopEverything();

        that.setDblClickZoomActive(false);
        that.deleteSelect = new ol.interaction.Select({
            wrapX: true,
            layers: [that.layer]
        });
    
        that.deleteSelect.on("select", function (event) {
            that.modifyFlag = true;
            selFeats        = new ol.Collection(event.selected);
    
            if (selFeats.getLength() !== 1) {
                //
                return;
            } else {
                that.layer.getSource().removeFeature(event.selected[0]);
                that.fireGeomChanged();
                that.initModifyInteraction();
                that.map.removeInteraction(that.deleteSelect);
                callback();
                that.setDblClickZoomActive(true);
            }
        });
        that.map.addInteraction(that.deleteSelect);
    },

    removeDeleteInteraction: function() {
        var that = this;
        that.map.removeInteraction(that.deleteSelect);
    }



});

module.exports = GenericGeometryEditor;


//////////////////
// WEBPACK FOOTER
// ./src/View/GenericGeometryEditor/index.js
// module id = 235
// module chunks = 0